<template>
    <div>
        <nav class="navbar navbar-expand-lg navbar-light">
            <div class="ml-auto">
                <form v-on:keypress.enter.prevent="searchData" class="form-inline my-2 my-lg-0">
                    <multiselect
                            class="form-control select"
                            v-model="search.customer"
                            :options="optionCustomer"
                            :customLabel="customerLabel"
                            :show-labels="false"
                            placeholder="ค้นหาลูกค้า"
                            track-by="id">
                    </multiselect>
                    <multiselect
                            class="form-control select"
                            v-model="search.seller"
                            :options="OptionSeller"
                            :customLabel="customLabel"
                            :show-labels="false"
                            placeholder="ค้นหา Sale"
                            v-if="canSaleOrdersAllView"
                            track-by="sale_id">
                    </multiselect>
                    <button
                        class="btn btn-success my-2 my-sm-0"
                        type="button"
                        @click="searchData">
                        <icon name="search"></icon> ค้นหา
                    </button>
                    &nbsp;&nbsp;
                    <template v-if="canCustomerCustomersCreate">
                        <router-link to="customer-information">
                            <button
                                    class="btn btn-warning my-2 my-sm-0"
                                    type="button">
                                <icon name="plus"></icon> เพิ่มลูกหนี้
                            </button>
                        </router-link>
                    </template>
                    &nbsp&nbsp
                    <button class="btn btn-primary my-2 my-sm-0"
                            @click="printReportCustomer"
                            type="button">
                        <icon name="print"></icon> นำออกรายงาน
                    </button>
                    &nbsp&nbsp
                    <button class="btn btn-primary my-2 my-sm-0"
                            @click="showprintCustomerOther"
                            type="button">
                        <icon name="print"></icon> รายงานลูกค้าย่อย
                    </button>
                </form>
            </div>
        </nav>
        <!-- table -->
        <div class="col-sm-12 table-responsive">
            <table style="text-align: center" class="table table-bordered">
                <thead>
                <tr>
                    <th scope="col">รหัสลูกหนี้</th>
                    <th scope="col">ชื่อลูกหนี้/ชื่อร้าน</th>
                    <th scope="col">ที่อยู่</th>
                    <th scope="col">เบอร์โทรศัพท์</th>
                    <th scope="col">Sale</th>
                    <th scope="col">เครดิตลิมิต</th>
                    <th scope="col">เครดิตที่ใช้ไป</th>
                    <template v-if="canCustomerCustomersUpdate">
                        <th scope="col">แก้ไข / ลบ</th>
                    </template>
                </tr>
                </thead>
                <tbody>
                <tr v-for="data in customer">
                    <td>{{ data.customer_id }}</td>
                    <td>
                        <template v-if="data.store_name">
                            {{ data.store_name }}
                        </template>
                        <template v-else>
                            {{data.first_name}}
                        </template>
                    </td>
                    <td>{{ data.address }}</td>
                    <td>{{ data.phone }}</td>
                    <td>
                        <template v-if="data.sale">
                            {{data.sale.sale_id}} {{data.sale.name}}
                        </template>
                    </td>
                    <td>{{ data.credit_limit | currency }}</td>
                    <td>
                        <template v-if="data.sale && (user.id == data.sale.sale_id) || canCustomerCustomersAllCreditLimitView">
                            {{ data.credit_usage | currency }}
                        </template>
                    </td>
                    <template v-if="canCustomerCustomersUpdate">
                        <td>
                            <a @click="updateCustomer(data.id)">
                                <icon name="pencil-alt"></icon>
                            </a>
                        </td>
                    </template>
                </tr>
                </tbody>
            </table>
        </div>
        <div v-if="customer.length > 0">
            <vue-pagination :pagination="dataPaginate"
                            @paginate="getCustomerPage">
            </vue-pagination>
        </div>
        <b-modal
            ref="customer_list"
            hide-header
            hide-footer>
            <div style="text-align: center;">
                <h4>เลือกลูกค้าที่ต้องการแสดง</h4>
                <h5 style="color: red">*ถ้าไม่เลือก จะแสดงลูกค้าทั้งหมดที่มีลูกค้าย่อย</h5>
                <br />
                <div class="row">
                    <div class="col-12">
                        <multiselect
                            class="form-control select"
                            v-model="customerList"
                            :options="optionCustomer"
                            :customLabel="customerLabel"
                            :multiple="true"
                            style="height: 100%;width: 95%"
                            :show-labels="false"
                            :close-on-select="false"
                            placeholder="ค้นหาลูกค้า"
                            track-by="id">
                        </multiselect>
                    </div>
                </div>
                <br />
                <button type="button"
                        class="btn btn-success"
                        @click="printCustomerOther">ตกลง
                </button>
                &nbsp&nbsp
                <button type="button"
                        class="btn btn-outline-secondary"
                        @click="hideprintCustomerOther">ยกเลิก
                </button>
            </div>
        </b-modal>
        <br />
    </div>
</template>

<script>
import { mapState } from "vuex"
import Multiselect from "vue-multiselect";
import VuePagination from "../../Pagination";
import {
    canCustomerCustomersAllCreditLimitView,
    canCustomerCustomersCreate,
    canCustomerCustomersUpdate,
    canSaleOrdersAllView,
} from "../../../util/Permissions"
import {domain} from "../../../util/Constants";

export default {
    name: "customer-data",
    components:{
        VuePagination,
        Multiselect},
    data() {
        return {
            id: "",
            keyword_customer: "",
            keyword_seller: "",
            event_submit : false,
            optionCustomer : [],
            customerList:[],
        };
    },
    created() {
        this.$store.dispatch("Customer/setCustomer");
        this.$store.dispatch('Seller/get');
        this.$store.dispatch("Customer/clearSearch");
        this.getCustomerAll();
    },
    computed: {
        canCustomerCustomersAllCreditLimitView,
        canCustomerCustomersCreate,
        canCustomerCustomersUpdate,
        canSaleOrdersAllView,
        ...mapState({
            customer: (state) => {
                return state.Customer.data;
            },
            OptionSeller: state =>{
                return state.Seller.data;
            },
            dataPaginate:state=>{
                return state.Customer.dataPaginate;
            },
            user: state => {
                return state.Auth.user
            },
            search:state =>{
                return state.Customer.search;
            }
        })
    },
    methods: {
        printCustomerOther(){
            let id_list = '';
            this.customerList.forEach((value, index) => {
                id_list += value.id+',';
            })
            window.open(domain+'/print_customer_with_other?id='+id_list,'_blank')
            this.hideprintCustomerOther();
        },
        showprintCustomerOther(){
            this.$refs.customer_list.show();
        },
        hideprintCustomerOther(){
            this.$refs.customer_list.hide();
        },
        customLabel (option) {
            return `${option.sale_id} - ${option.name}`
        },
        customerLabel(option){
            return `${option.customer_id} - ${option.store_name}`
        },

        //API
        updateCustomer(id) {
            this.$store.dispatch('Customer/show',id).then(()=>{
                this.$store.dispatch("Customer/getCustomerOtherByCustomerId",id).then(()=>{
                    this.$router.push({
                        name: "customer-information",
                        params: { id }
                    });
                })
            });
        },
        searchData() {
            let customer_id = "";
            let sale_id = "";
            if(this.search.customer){
                customer_id = this.search.customer.id;
            }
            if(this.search.seller){
                sale_id = this.search.seller.id
            }
            this.event_submit = true;
            this.$store.dispatch("Customer/search", {
                customer: customer_id,
                sale: sale_id
            });
        },
        getCustomerAll(){
            this.$store.dispatch("Customer/setAllCustomer").then(res=>{
                this.optionCustomer = res;
            });
        },
        getCustomerPage(){
            let page = this.dataPaginate.current_page;
            if(this.event_submit ){
                this.event_submit = true;
                let sale = "";
                if(this.search.seller){
                    sale = this.search.seller.id
                }
                this.$store.dispatch("Customer/search", {
                    page : page ,
                    customer: this.search.customer,
                    sale: sale
                });
            }
            else{
                const page = this.dataPaginate.current_page;
                this.$store.dispatch('Customer/setCustomer',page);
            }
        },
        printReportCustomer(){
            if(this.canSaleOrdersAllView){
                if(this.search.seller){
                    let sale_id = this.search.seller ? this.search.seller.id : '';
                    window.open(`${domain}/print_report_customer?sale_id=${sale_id}`,'_blank')
                }else{
                    alert('กรุณาเลือกเซลล์เพื่อออกรายงานลูกค้า');
                }
            }else{
                let sale_id = this.user.id;
                window.open(`${domain}/print_report_customer?sale_id=${sale_id}`,'_blank')
            }

        }
    }
};
</script>

<style lang="scss" scoped>
    thead {
        background-color: $thead-color;
        color: $font-table-color;
    }
    a {
        cursor: pointer;
    }
    .select {
        border: 0;
    }
</style>
